import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { resolveLocalizedText, isApp } from '../../../../utils';
import classNames from 'classnames';
import { ChangeContactView } from '../../components/ChangeContactView';
import {
  getChangeEmailLabels,
  getChangeEmailStepContext,
} from '../../selectors/changeEmailSelector';
import {
  getSelectedPolicy,
  getChangeContactPolicyCardsLength,
} from '../../selectors/changeContactSelector';
import InputField from '@axa-asia/emma-stylesheet/lib/components/Input/InputField';
import './style.scss';
import { goto } from '../../../../actions/historyActions';
import {
  updateNewEmail,
  updateEmailOtherPolices,
  updateSelectedList,
} from '../../actions/changeEmailAction';
import { getNewEmail, getIsLoading } from '../../selectors/changeEmailSelector';
import { t } from '../../../../locales';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import _ from 'lodash';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import loadingIcon from '../../../../assets/images/loading-white.png';
import browserHistory from '../../../../stores/browserHistory';
import LongLoadingView from '../../../../components/LongLoadingView';
import { POLICIES } from '../../constants/constants';
import { EmmaButton, EmmaText } from '@axa-asia/emma-stylesheet';

export interface ChangeEmailContainerProps {
  newEmail: string;
  updateNewEmail: (email: string) => any;
  updateSelectedList: (selectedList: any[]) => any;
  onUpdateEmailOtherPolices: () => any;
  selectedPolicy: any;
  changeEmailLabels: any;
  changeEmailStepContext: any;
  isLoading: boolean;
  policies: number;
}

export interface ChangeEmailContainerState {
  isError: boolean;
  isEmptyValue: boolean;
  isSameEmail: boolean;
  latestEmail: string;
}

export class ChangeEmailContainer extends Component<
  ChangeEmailContainerProps,
  ChangeEmailContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isError: false,
      isEmptyValue: true,
      isSameEmail: false,
      latestEmail: '',
    };
  }

  emailRef: any = createRef();

  onEmailChange = (target: any) => {
    const { selectedPolicy } = this.props;
    this.setState({
      isError: target.isError,
      isEmptyValue: target.value === '',
      isSameEmail:
        target.value !== '' &&
        _.toLower(target.value) === _.toLower(selectedPolicy.email),
      latestEmail: target.value ? target.value : '',
    });
    // updateNewEmail(target.value);
  };

  onGoNext = () => {
    const { latestEmail } = this.state;
    const { onUpdateEmailOtherPolices, updateNewEmail } = this.props;

    updateNewEmail(latestEmail);
    onUpdateEmailOtherPolices();
  };

  componentDidMount() {
    const { selectedPolicy, updateSelectedList } = this.props;

    updateSelectedList([]); // To clear selected policy list for user step back from applyToAll

    if (_.isEmpty(selectedPolicy)) {
      goto('emma-change-contact', undefined, undefined, true);
    }

    this.onEmailChange({ ...this.emailRef.state });

    if (isApp()) {
      const title = t(`CUSTOMER_PROFILE_UPDATE_EMAIL_TITLE`);
      if (title) {
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
      }
    }

    // registerHistoryIndex(CHANGE_EMAIL_EDIT_ID);
  }

  onGoBack = () => {
    const { selectedPolicy } = this.props;
    browserHistory.goBack();
    // goto('emma-customer-profile/contact-details?policy_number=' + selectedPolicy.policyNumber);
  };

  render() {
    const {
      newEmail,
      changeEmailLabels,
      changeEmailStepContext,
      isLoading,
      policies,
    } = this.props;
    const { isError, isEmptyValue, isSameEmail } = this.state;
    const nextDisabled = isError || isEmptyValue || isSameEmail;
    const editEmail = resolveLocalizedText(changeEmailLabels.editEmail);
    const enterNewEmail = resolveLocalizedText(changeEmailLabels.enterNewEmail);
    const emailErrorMsg = resolveLocalizedText(changeEmailLabels.emailErrorMsg);
    const nextBtnLabel = resolveLocalizedText(changeEmailLabels.nextBtnLabel);
    const sameEmailError = resolveLocalizedText(
      changeEmailLabels.sameEmailError,
    );
    const resolvedStepContext = resolveLocalizedText(
      changeEmailStepContext,
    ) as any;

    const remarksLabel = resolveLocalizedText(changeEmailLabels.remarksLabel);

    const inputEmailPlaceholder = changeEmailLabels.inputEmailPlaceholder
      ? resolveLocalizedText(changeEmailLabels.inputEmailPlaceholder)
      : '';

    return (
      <div className="Change-Email">
        <ChangeContactView
          onGoBack={this.onGoBack}
          pageName={editEmail}
          stepContext={resolvedStepContext}
          activeIndex={0}
        >
          {isLoading ? (
            <LongLoadingView isShowText={policies > POLICIES} />
          ) : (
            <div className="emma-stylesheet-grid-system">
              <div className="row">
                <div className="col-12">
                  <div className="emma-stylesheet-label change-contact-heading change-contact-input">
                    <label
                      className="emma-stylesheet-label__text"
                      htmlFor="text1"
                    >
                      {enterNewEmail}
                    </label>
                  </div>
                </div>
              </div>
              <div className="row new-email-wrapper">
                <div
                  className={`new-email-input ${
                    isSameEmail ? 'same-email-error' : ''
                  }`}
                >
                  <InputField
                    ref={(ref: any) => (this.emailRef = ref)}
                    childrenClassName="col-12 change-contact-input"
                    enableCount={false}
                    errorMessage={emailErrorMsg}
                    isCustomValidation={false}
                    isValidateInitValue={false}
                    value={newEmail}
                    mandatory
                    maxLength={50}
                    placeholder={inputEmailPlaceholder}
                    onChange={this.onEmailChange}
                    type="email"
                  />
                  {isSameEmail ? (
                    <div className="custom-error-wrapper">{sameEmailError}</div>
                  ) : null}
                </div>
                <p className={EmmaText['Remarks_Error/Loose/Left/MineShaft']}>
                  {remarksLabel}
                </p>
              </div>
              <div className="row Change-Email__button content-align">
                <EmmaButton
                  data-enable-ga
                  data-ga-type="button"
                  disabled={nextDisabled || isLoading}
                  variant="primary"
                  onClick={this.onGoNext}
                  loading={isLoading}
                >
                  {nextBtnLabel}
                </EmmaButton>
              </div>
            </div>
          )}
        </ChangeContactView>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeEmailLabels = getChangeEmailLabels(state);
    const changeEmailStepContext = getChangeEmailStepContext(state);
    const newEmail = getNewEmail(state);
    const selectedPolicy = getSelectedPolicy(state);
    const isLoading = getIsLoading(state);
    const policies = getChangeContactPolicyCardsLength(state);

    return {
      changeEmailLabels,
      changeEmailStepContext,
      newEmail,
      selectedPolicy,
      isLoading,
      policies,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      updateNewEmail: (newEmail: string) => dispatch(updateNewEmail(newEmail)),
      onUpdateEmailOtherPolices: () => dispatch(updateEmailOtherPolices()),
      updateSelectedList: (selectedList: any[]) =>
        dispatch(updateSelectedList(selectedList)),
    };
  }
}

export default connect(
  ChangeEmailContainer.mapStateToProps,
  ChangeEmailContainer.mapDispatchToProps,
)(ChangeEmailContainer);
